import { selectIsInternalAdmin } from 'accessors'
import { useSelector } from 'react-redux'

import DowngradeButton from './DowngradeButton/index'
import UpgradeButton from './UpgradeButton/index'

const userPermissionLevels = {
  HasPermission: 'HasPermission',
  HasGroupLevelPermission: 'HasGroupLevelPermission',
  NoPermission: 'NoPermission'
}

const { HasPermission, HasGroupLevelPermission } = userPermissionLevels

const UserPermissionCheckbox = ({
  handleChange,
  accessLevel,
  id,
  disabled,
  isUpgradeable,
  handleUpgradeClick,
  handleDowngradeClick,
  label,
  height
}) => {
  const isCheckboxChecked = [HasPermission, HasGroupLevelPermission].includes(accessLevel)

  const isCheckboxDisabled = disabled || accessLevel === HasGroupLevelPermission

  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  return (
    <label htmlFor={id} className="userPermissionCheckbox" style={{ height }}>
      <span className="userPermissionCheckbox-label">{label}</span>
      {isInternalAdmin && (
        <>
          {accessLevel === HasPermission && isUpgradeable && (
            <UpgradeButton label={label} handleClick={handleUpgradeClick} />
          )}
          {accessLevel === HasGroupLevelPermission && (
            <DowngradeButton handleClick={handleDowngradeClick} canDowngrade={true} />
          )}
        </>
      )}
      <input
        type="checkbox"
        checked={isCheckboxChecked}
        id={id}
        onChange={handleChange}
        disabled={isCheckboxDisabled}
      />
      <div className="swp-custom-checkbox">
        <div className="swp-custom-checkbox__check"></div>
      </div>
    </label>
  )
}

export default UserPermissionCheckbox
